import React from "react";
import InputField from "../../../Components/InputField";
import { Box, Card } from "@mui/material";
import CustomTypography from "../../../Components/Typography";
import muiStyles from "../styles/muiStyles";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import PhoneNumberInput from "../../../Components/PhoneNumberInput";

const ContactDetails = (props) => {
  const { isloading } = props;
  const { t } = useTranslation("page-business-settings");
  const { cardStyles, inputGridStyles } = muiStyles;

  const { handleChange, handleBlur, values, touched, errors, setFieldValue } =
    useFormikContext();

  return (
    <Card sx={{ ...cardStyles, overflow: "unset" }}>
      <CustomTypography type="subheading">
        {t("contact_details_heading")}
      </CustomTypography>

      <Box
        sx={{
          ...inputGridStyles,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          pt: "32px",
        }}
      >
        <InputField
          name="contactFullName"
          label={t("contact_full_name")}
          value={values.contactFullName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("placeholder_full_name")}
          disabled={isloading}
          error={touched.contactFullName && Boolean(errors.contactFullName)}
          helperText={touched.contactFullName && errors.contactFullName}
        />

        <PhoneNumberInput
          wrapperId="business-settings-phone-input"
          label={t("contact_phone")}
          disabled={isloading}
          prefixName="contactPhonePrefix"
          phoneNumberName="contactPhoneNumber"
          prefixValue={values.contactPhonePrefix}
          phoneNumber={values.contactPhoneNumber}
          phoneNumberPlaceholder={t("placeholder_phone")}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          errors={errors}
        />

        {/* <InputField
          name="contactPhone"
          label={t("contact_phone")}
          type="tel"
          value={values.contactPhone}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("placeholder_phone")}
          disabled={isloading}
          error={touched.contactPhone && Boolean(errors.contactPhone)}
          helperText={touched.contactPhone && errors.contactPhone}
        /> */}

        <InputField
          name="contactEmail"
          type="email"
          label={t("contact_email")}
          value={values.contactEmail}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("placeholder_email")}
          disabled={isloading}
          error={touched.contactEmail && Boolean(errors.contactEmail)}
          helperText={touched.contactEmail && errors.contactEmail}
        />
      </Box>
    </Card>
  );
};

export default ContactDetails;
